import { schedule_types_ids } from "constants/schedule";

export const VIEW_RECORDING_AWS_CREDS = {
  accessKeyId: `${process.env.REACT_APP_EXLY_S3_ACCESS_KEY_ID}`,
  secretAccessKey: `${process.env.REACT_APP_EXLY_S3_SECRET_ACCESS_KEY}`,
  region: `${process.env.REACT_APP_S3_REGION}`,
};

export const VIEW_RECORDING_BUCKET = process.env.REACT_APP_EXLY_S3_BUCKET;

export const MAX_SESSIONS_DAYS_COUNT = 90;

export const NONE_OPTION_SECTION_VALUE = "none";
export const NEW_SECTION_OPTION_VALUE = "new section";

export const FIRST_ITEM_INDEX = 0;
// Onboarding flow, tooltip weights. Here either batch name or session name or
// customer name column will be rendered, so both have same weights
export const MANAGE_RECORDING_TOOLTIP_WEIGHTS = {
  recording_name: "1",
  section_name: "2",
  create_section: "3",
  batch_name: "4",
  session_name: "4",
  customer_name: "4",
  save_button: "5",
};

export const MANAGE_RECORDING_TOOLTIP_DATA = {
  recording_name:
    "Easily find recordings! All the zoom recordings that could not be added to your recordings course automatically, will be added here in this way.",
  section_name:
    "Want to add this recording in the course? Just select a section where you’d like to add this recording.",
  create_section:
    "Not sure where to add? No worries. Create a new section on the go! You can add a new section in your course directly from here itself!",
  batch_name:
    "Easily link the recording to its respective batch. The recording access will go to this selected batch.",
  session_name:
    "Easily link the recording to its respective session. The recording access will go to the customers of that selected session.",
  customer_name:
    "Easily link the recording to its respective participant. The recording access will go to this selected customer.",
  save_button:
    "Chosen a location for your recording? Click on ‘Save changes’ and your recording will be shifted to your course in just a single tap!",
};

export const empty_state_props = {
  empty_list_icon: "/assets/images/manage_recordings/empty_state_icon.svg",
  alt: "no recordings yet.",
  content_title: "No unmapped recordings.",
  children:
    "Hurray! All your recordings are already mapped and shared with your customers.",
};

export const column_item_keys = {
  batch: "batch",
  session: "session",
  customer: "customer",
};

export const column_keys = {
  recordings: {
    apiKey: "name",
    headerName: "Topic",
  },
  fileType: {
    apiKey: "file_type",
    headerName: "File type",
  },
  startedOn: {
    apiKey: "start_datetime",
    headerName: "Started on",
  },
  endedOn: {
    apiKey: "end_datetime",
    headerName: "Ended on",
  },
  size: {
    apiKey: "file_size",
    headerName: "Size",
  },
  downloadExpiry: {
    apiKey: "download_token",
    headerName: "Download link expiry",
  },
  downloadAction: {
    apiKey: "download_url",
    headerName: "Action",
  },
  recordingId: {
    apiKey: "uuid",
    headerName: "Section in Course",
  },
  password: {
    apiKey: "password",
    headerName: "Password",
  },
};

export const manage_recordings_onboarding_keys = {
  [schedule_types_ids.one_on_one_appointment]: "manage_recording_appointment",
  [schedule_types_ids.rolling_class]: "manage_recording_rolling",
  [schedule_types_ids.group_class]: "manage_recording_group",
  [schedule_types_ids.workshop]: "manage_recording_workshop",
  [schedule_types_ids.no_schedule]: "manage_recording_qpp",
  [schedule_types_ids.webinar]: "manage_recording_webinar",
};

export const RECORDING_TABS = {
  UNMAPPED_RECORDINGS: "unmapped_recordings",
  MANAGE_RECORDINGS: "manage_recordings",
};

export const RECORDING_TAB_OPTIONS = [
  { label: "Unmapped Recordings", value: RECORDING_TABS.UNMAPPED_RECORDINGS },
  { label: "Manage Recordings", value: RECORDING_TABS.MANAGE_RECORDINGS },
];

export const RECORDING_QUERY_PARAM = {
  RC: "rc_listing_uid",
  OTHER: "origin_listing_uuid",
};

export const MANAGE_RECORDINGS_HOOK_TEXTS = {
  CREATE_NEW_SECTION_LABEL: "Create new section +",
  NO_OFFERING_SELECTED: "No offering selected!",
  SELECT_BATCH_ERROR: "Please select a batch alongside of the mapped section!",
  SELECT_SESSION_ERROR:
    "Please select a session alongside of the mapped section!",
  SELECT_CUSTOMER_ERROR:
    "Please select a customer alongside of the mapped section!",
  MAP_ATLEAST_ONE_ERROR:
    "Please map atleast one recording to a section to proceed!",
  CUSTOM_REQ_OCCURED_AT:
    "getZoomRcOfferingDetails in src/ui/pages/schedule/ManageOffering/ManageRecordings/hooks/useManageRecordings.js",
  CUSTOM_REQ_WHEN: "when offering detail api is being hit for zoom rc offering",
  PARTICIPANTS_PAGE_ALL: "all",
  INITIAL_SECTION_OPTION_NONE_LABEL: "-",
  NONE_SECTION_OPTION_ID: 0,
  NEW_SECTION_OPTION_ID: 1,
};

export const RECORDING_SETTINGS_MODAL_CONSTANTS = {
  BUTTON_TITLE: "Settings",
  MODAL_TITLE: "Settings",
  CANCEL_BTN_TEXT: "Cancel",
  SAVE_BTN_TEXT: "Save details",
  SUCCESS_MESSAGE: "Recording settings saved successfully",
  ERROR_MESSAGE: "Failed to save recording settings",
  MODAL_WIDTH: "560px",
};
